<div class="sk-cms-mimage {{basic.style.type}}"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>

    {{if style.isShowTitle == '1'}}
        <% include('../common/title.art', {title: basic.title}) %>
    {{/if}}

    {{if !content || content.length == 0}}
         <% include('../common/nodata.art') %>
    {{else}}
    <div class="mimage-main">
        {{each content}}
        <div class="mimage-list" style="{{style.isShowMargin != 1 ? 'margin-right: 0; width: 50%' : ''}};">
            {{if $value.linkType != 'none' && !isDesign}}
            <a class="goto-link" target="_blank" href="{{$value.link}}">
            {{/if}}
                <img src="{{$value.imgUrl}}" alt="">
            {{if $value.linkType != 'none' && !isDesign}}
            </a>
            {{/if}}
        </div>
        {{/each}}
    </div>
    {{/if}}
</div>
